import {useApi} from "~/composables/api/utils/useApi"

export const useShopApi = () => ({
  async getBySlug(slug) {
    const url = `shops/${slug}`
    const api = useApi()

    return api.makeRequest(url, 'get')
  },

  async getList(sort = '', limit = 500) {
    const api = useApi()
    let url = `shops?limit=${limit}`
    if (sort) {
      url += `&sort=${sort}`
    }

    return api.makeRequest(url, 'get')
  },

  async getPickupList(sort = '', limit = 500) {
    const api = useApi()
    let url = `shops?limit=${limit}&filter[allow_pickup]=1`
    if (sort) {
      url += `&sort=${sort}`
    }

    return api.makeRequest(url, 'get')
  }
})
